var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpArrowRightBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3974_5399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3082 1.02255C3.19102 1.13976 3.12519 1.29871 3.12519 1.46444C3.12519 1.63018 3.19102 1.78913 3.3082 1.90634L6.40195 5.00009L3.3082 8.09384C3.19793 8.21229 3.13791 8.36889 3.14076 8.5307C3.1436 8.69251 3.2091 8.8469 3.32347 8.9614C3.43784 9.07589 3.59216 9.14156 3.75397 9.14459C3.91577 9.14762 4.07244 9.08776 4.19101 8.97763L7.72715 5.44247C7.84433 5.32526 7.91016 5.16631 7.91016 5.00058C7.91016 4.83484 7.84433 4.67589 7.72715 4.55868L4.19199 1.02255C4.07478 0.905368 3.91583 0.839539 3.75009 0.839539C3.58436 0.839539 3.42541 0.905368 3.3082 1.02255Z",
    fill: "#DFD8D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3974_5399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(10) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpArrowRightBold);
export default __webpack_public_path__ + "static/media/ep_arrow-right-bold.92dc064f021638c675ac93a80059c51b.svg";
export { ForwardRef as ReactComponent };